export const THEMES = {
  blackAndWhite: "/iconTheme.png",
  sepia: "/iconTheme.png",
  rainy: "/iconCloud.png",
};
